import { BaseError } from "./BaseError";
/**
 * AssetLoadingError
 */ export class AssetLoadingError extends BaseError {
    constructor(name, message){
        super();
        this.name = "AssetLoadingError";
        this.message = `${name}${message ? ". " + message : ""}`;
    }
}
